import {DateTabsType} from 'utils/types';
import {useCallback, useEffect} from 'react';
import {DateTabsState} from 'store/dateTabs/types';
import setDateTabsThunk from 'store/dateTabs/actions/setDateTabs';
import setSelectedDateTabThunk from 'store/dateTabs/actions/setSelectedDateTab';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from 'store/types';
import setDateTabsTypeThunk from 'store/dateTabs/actions/setDateTabsType';
import {dateTabsTotal, getDateTabs} from 'store/dateTabs/utils';

// BIQ: tabs creation logic should maybe go into store action?
// TODO: complete documentation

type UseDateTabsHook = [
  DateTabsState,
  {
    setDateTabsType: typeof setDateTabsTypeThunk;
    setSelectedDateTab: (index?: number) => void;
  }
];

const dateTabsSelector = (state: AppState): DateTabsState => ({
  tabsType: state.dateTabs.tabsType || DateTabsType.DAYS,
  tabs: state.dateTabs.tabs || getDateTabs(DateTabsType.DAYS), // FIXME: detect type from url filter on startup?
  selectedTabIndex:
    state.dateTabs.selectedTabIndex ?? Math.floor(dateTabsTotal[DateTabsType.DAYS] / 2),
});

const useDateTabs = (): UseDateTabsHook => {
  const dispatch = useDispatch();
  const state = useSelector(dateTabsSelector);
  const {tabsType, tabs, selectedTabIndex} = state;

  const setDateTabsType = useCallback(
    (type: DateTabsType) => {
      return dispatch(setDateTabsTypeThunk(type));
    },
    [dispatch]
  );

  const setSelectedDateTab = useCallback(
    (index?: number) => {
      const newIndex =
        index !== undefined && index < dateTabsTotal[tabsType]
          ? index
          : Math.floor(dateTabsTotal[tabsType] / 2);
      return dispatch(setSelectedDateTabThunk(newIndex));
    },
    [dispatch, tabsType]
  );

  useEffect(() => {
    const dateTabs = getDateTabs(tabsType);
    dispatch(setDateTabsThunk(dateTabs));
  }, [dispatch, tabsType]);

  return [state, {setDateTabsType, setSelectedDateTab}];
};

export default useDateTabs;
